import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import Avatar from 'components/Avatar';
import ContractEmployeeEdit from "./ContractEmployeeEditModal";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";
import { showModal, hideModal } from "actions/modalActions";
import { FiPlus, FiMoreHorizontal, FiChevronDown, FiChevronUp } from "react-icons/fi";

class ContractEmployees extends React.Component {

	constructor(props) {
		super(props);
		// console.log(props);
		this.state = {
			showInactive: false
		};
		this.scrollContainerRef = React.createRef();
		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeesContractModal = this.openNewEmployeesContractModal.bind(this);
	}

	getSnapshotBeforeUpdate(prevProps, prevState) {
		if (prevState.showInactive !== this.state.showInactive) {
			const container = this.scrollContainerRef.current;
			return container ? container.scrollTop : null;
		}
		return null;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (snapshot !== null) {
			const container = this.scrollContainerRef.current;
			if (container) {
				container.scrollTop = snapshot;
			}
		}
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewEmployeesContractModal(contract) {
		this.closeModal();
		this.props.showModal(
			{
				open: true,
				title: this.props.t("contracts.employees.addEmployees"),
				style: { width: "400px" },
				content: (
					<ContractEmployeeEdit getContracts={this.props.getContracts} handleClose={this.closeModal} contract={contract} />
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	toggleInactive = (e) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		this.setState((prevState) => ({
			showInactive: !prevState.showInactive
		}));
	}

	getEmptyRow = () => {
		return (
			<tr>
				<td colSpan={2} className="no-result">
					{this.props.t("contracts.employees.noEmployeesAssigned")}
				</td>
			</tr>
		);
	}

	getRows = (employees) => {
		return employees.map((employee) => {
			return (
				<tr key={employee.id}>
					<td colSpan={2} >
						<Avatar userId={employee.id} className="avatar-sm" alt={employee.name} />

						<EmployeeLink
							className="table-link"
							employee={employee}
						>
							{employee.name} {employee.surname}
						</EmployeeLink>
					</td>
				</tr>
			)
		});
	}

	render() {
		const { contract, useFullHeight } = this.props;
		const { showInactive } = this.state;

		const employees = contract && contract.employees ? contract.employees : [];

		const sortEmployees = (a, b) => {
			const nameA = `${a.name} ${a.surname}`.toLowerCase();
			const nameB = `${b.name} ${b.surname}`.toLowerCase();
			if (nameA < nameB) return -1;
			if (nameA > nameB) return 1;
			return 0;
		};

		const activeEmployees = employees.filter(e => e.enabled).sort(sortEmployees);
		const inactiveEmployees = employees.filter(e => !e.enabled).sort(sortEmployees);

		const containerStyle = useFullHeight
			? { height: "100%", overflowY: "auto" }
			: { maxHeight: "600px", overflowY: "auto" };

		return (
			<div className="contract-employees-scroll" style={containerStyle} ref={this.scrollContainerRef}>
				<div className="active-employees-section">
					<table className="table table-employees-in-contract table-zebra-reverse">
						<thead>
							<tr>
								<th>{this.props.t("contracts.employees.employee")}</th>
								<th className="td-actions">
									<button
										type="button"
										title={this.props.t("contracts.employees.addEmployees")}
										onClick={() => this.openNewEmployeesContractModal(contract)}
										className="btn btn-new"
									>
										<FiPlus />
									</button>
								</th>
							</tr>
						</thead>
						<tbody>
							{activeEmployees.length > 0 ?
								this.getRows(activeEmployees)
								:
								this.getEmptyRow()
							}
						</tbody>
					</table>
				</div>

				{inactiveEmployees.length > 0 && (
					<div className="inactive-employees-section">
						<button
							type="button"
							className="btn-transparent btn-toggle-inactive"
							onClick={this.toggleInactive}
							style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px', color: '#888' }}
						>
							{showInactive ? this.props.t("contracts.employees.hideInactiveUsers") : this.props.t("contracts.employees.viewInactiveUsers", { count: inactiveEmployees.length })}
							{showInactive ? <FiChevronUp /> : <FiChevronDown />}
						</button>

						{showInactive && (
							<table className="table table-employees-in-contract table-zebra-reverse mt-2" style={{ opacity: 0.7 }}>
								<tbody>
									{this.getRows(inactiveEmployees)}
								</tbody>
							</table>
						)}
					</div>
				)}
			</div>
		)
	}
}




const mapStateToProps = (reducers) => {
	return {
		...reducers.contractsReducer,
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
	};
};


const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContractEmployees));